export enum LiquidityPoolTab {
  DEPOSIT = 'deposit',
  WITHDRAW = 'withdraw',
}

export enum LiquidityPoolTransaction {
  USER_TRANSACTIONS = 'user-transactions',
  YOUR_TRANSACTIONS = 'your-transactions',
}

export enum LiquidityPoolPnlType {
  PNL_PER_ROUND = 'pnl-per-round',
  CUMULATIVE_PNL = 'cumulative-pnl',
}

export enum LiquidityPoolCollateral {
  USDC = 'usdc',
  WETH = 'weth',
  THALES = 'thales',
  OVER = 'over',
  cbBTC = 'cbbtc',
  wBTC = 'wbtc',
}
